var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-globalAlert" },
    [
      _c(_vm.activeAlert, {
        tag: "component",
        staticClass: "c-globalAlert_component",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }